import axios from 'axios';

export const SET_SIZE = 'SET_SIZE';
export const SET_TOTAL = 'SET_TOTAL';


export default {
    namespaced: true,
    state: {
        size: null,
        total: null
    },
    mutations: {
        [SET_SIZE](state, size) {
            state.size = size;
        },
        [SET_TOTAL](state, total) {
            state.total = total;
        },
    },
    actions: {
        addProduct({ commit }, { endpoint, qty }) {
            return axios.post(endpoint, { qty }).then(response => {
                let { size, total } = response.data;
                commit(SET_SIZE, size);
                commit(SET_TOTAL, total);
            });
        }
    }
}